import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import env from '../../env';
import { getSirvImgUrlExterior } from '../../modules/Vehicles/helpers';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import cn from 'classnames';
import styles from './VehicleAvatarWeblogin.module.css';
import ImageCarouselComponent from '../../containers/App/Components/Carousel/Carousel';
// import Modal and Carousel components if not already imported

const Container = styled.div`
  margin: 20px;

  .img {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    width: 350px;
    height: 350px;
    clip-path: inset(15px 0 0 0);

    @media (max-width: 410px) {
      width: 250px;
      height: 250px;
    }
  }
`;

export const VehicleAvatar = function(props) {
  const [showCarousel, setShowCarousel] = useState(false);
  const [carouselImages, setCarouselImages] = useState([]);

  // useEffect(() => {
  //   props.getPhotos(result => {
  //     if (result?.length) {
  //       setCarouselImages(result);
  //     }
  //   });
  // }, []);

  const renderPhotoCarousel = () => {
    // Render your carousel component here
  };

  const openCarousel = e => {
    e.stopPropagation();
    setShowCarousel(true);
  };

  const closeCarousel = () => {
    setShowCarousel(false);
  };

  let url = getSirvImgUrlExterior(props.vehicle?.helga_id || props.vehicle?.id, '01');
  if (env.disable_SIRV) {
    url = '';
  }

  return (
    <>
      <Container className="avatar" vehicle={props.vehicle}>
        {showCarousel && renderPhotoCarousel()}
        {env.disable_SIRV ? (
          <div
            onClick={e => (!props.withoutSlide ? openCarousel(e) : props.onClick())}
            className="img bottom"
            style={{
              backgroundImage: `url('${carouselImages?.length && carouselImages[0]?.url}'), url('/public/images/placeholder.png')`,
            }}
          ></div>
        ) : (
          <div
            className="img bottom"
            style={{
              backgroundImage: `url('${getSirvImgUrlExterior(
                props.vehicle?.helga_id || props.vehicle?.id,
                '01',
              )}'), url('/public/images/placeholder.png')`,
            }}
          ></div>
        )}
      </Container>
    </>
  );
};
